import { createSelector } from '@ngrx/store';
import { CommonState, selectCommonState } from '../common.state';

export const selectCommonUserLocation = createSelector(selectCommonState, (state: CommonState) => state.userLocation);
export const selectCommonGpsReady = createSelector(selectCommonState, (state: CommonState) => state.gpsReady);
export const selectCommonAppSettings = createSelector(selectCommonState, (state: CommonState) => state.appSettings);
